<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_16763_31034"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_16763_31034)">
      <circle
        cx="10.5"
        cy="11"
        r="6.375"
        stroke="#666666"
        stroke-width="1.5"
        class="stroke"
      />
      <circle
        cx="10.5002"
        cy="15.25"
        r="0.354167"
        fill="#666666"
        stroke="#666666"
        stroke-width="1.5"
        class="stroke"
      />
      <path
        d="M10.5 13.8333V12.8283C10.5 12.1595 10.928 11.5657 11.5625 11.3542V11.3542C12.197 11.1427 12.625 10.5489 12.625 9.88004V9.51654C12.625 8.37983 11.7035 7.45834 10.5668 7.45834H10.5C9.32639 7.45834 8.375 8.40974 8.375 9.58334V9.58334"
        stroke="#666666"
        stroke-width="1.5"
        class="stroke"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
